import React from 'react'

import styles from './strip.module.css'

const Strip = () => (
  <div>
    <div className={styles.notice}>
      Unslant is currently offline due to server costs. You can still get the
      extension, but no suggestions will be surfaced.
    </div>
    <div className={styles.strip} />{' '}
  </div>
)

export default Strip
